<template>
<div>
    <div class="mobile-menu mobile-menu-hidden">
        <div class="menu-logo" v-if="auth.language !== 'dostavkauk'">
            <router-link to="/">
                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/mobile-menu/logo.png">
            </router-link>
        </div>

        <div class="menu-container">
            <ul>
                <li>
                    <router-link to="/restaurants">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/mobile-menu/icon_all_restorans.png"> Все рестораны
                    </router-link>
                </li>
                <li>
                    <router-link to="/stock">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/mobile-menu/icon_action.png"> Акции и подарки
                    </router-link>
                </li>
                <li>
                    <router-link to="/cart">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/mobile-menu/icon_basket.png"> Корзина
                    </router-link>
                </li>
                <li @click="showModal('login')" class="enter_sign_up" v-if="!auth.user">
                    <a><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/person.svg"> Вход/Регистрация</a>
                </li>
                <router-link tag="li" v-if="auth.user" to="/cabinet"><a href=""> <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/header/person.svg"> Личный кабинет</a></router-link>
                <li v-if="auth.user" @click="sendLogout"><a href="">Выход</a></li>
            </ul>
        </div>
        <div class="menu-container-second" v-if="auth.language !== 'dostavkauk'">
            <ul>
                <li class="menu-selected-country">
                    Выбрать страну
                </li>
                <li @click="showModal('selectCity')">
                    <a>Выбрать город</a>
                </li>
                <li><router-link to="/restaurants_services">Ресторанам</router-link></li>
                <li><router-link to="/investment">Заработать с нами</router-link></li>
            </ul>
        </div>
        <div class="menu-list-country" v-if="auth.language !== 'dostavkauk'">
            <ul>
                <li class="return-from-list-country"><div class="icon-back-from-list-country"></div></li>
                <li><a href="https://xn----jtbzbeohcqv6d.xn--p1ai/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/rf.png" alt="Россия"> Россия</a></li>
                <li><a href="https://xn----jtbzbeohcqv6d.xn--j1amh/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/ua.png" alt="Україна"> Україна</a></li>
                <li><a href="https://xn----jtbzbeohcqv6d.xn--90ais/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/bl.png" alt="Беларусь"> Беларусь</a></li>
                <li><a href="https://when-hungry.md/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/md.png" alt="Moldova"> Moldova</a></li>
                <li><a href="https://xn----jtbzbeohcqv6d.xn--80ao21a/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/kz.png" alt="Қазақстан"> Қазақстан</a></li>
                <li><a href="https://www.hochu-poest.kg/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/kg.png" alt="Кыргызстан"> Кыргызстан</a></li>
                <li><a href="https://when-hungry.lv/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/lv.png" alt="Latvija"> Latvija</a></li>
                <li><a href="https://when-hungry.am/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/am.png" alt="Հայաստան"> Հայաստան</a></li>
                <li><a href="https://when-hungry.club/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/ge.png" alt="საქართველო"> საქართველო</a></li>
                <li><a href="https://hochu-poest.uz/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/uz.png" alt="O'zbekiston"> O'zbekiston</a></li>
                <li><a href="https://when-hungry.online/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/app/img/footer/az.png" alt="Azərbaycan"> Azərbaycan</a></li>
            </ul>
        </div>

    </div>
    <div class="menu-button">
        <span></span>
    </div>
    <div class="back_btn" @click="upbtn">
      <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static//img/main_page/arrow_top.svg" />
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
export default {
  name: 'mobileMenu',
  props: ['city', 'auth', 'basket', 'geo'],
  methods: {
    showModal (val) {
      this.$root.modals = val
      $('.menu-button').trigger('click')
    },
    sendLogout () {
      var formData = new FormData()
      formData.append('user', null)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        window.location.href = '/'
      })
    },
    upbtn () {
      $('html, body').stop().animate({scrollTop: 0}, 300)
    }
  }
}
window.onload = function () {
  (function () {
    var mobileMenu = document.querySelector('.mobile-menu')
    // var mobileMenuLogo = document.querySelector('.menu-logo')
    var mobileHamburger = document.querySelector('.menu-button')
    // var mobileMenuContainer = document.querySelector('.menu-container')
    // var mobileMenuSecondContainer = document.querySelector('.menu-container-second')
    /* Описываем раскрытие и закрытие бокового меню по нажатию на кнопку "Гамбургер" */
    var toggleMenu = function () {
      mobileMenu.classList.toggle('mobile-menu-hidden')
    }
    var toggleButton = function () {
      if (mobileMenu.classList.contains('mobile-menu-hidden')) {
        mobileHamburger.style.left = 10 + 'px'
        mobileHamburger.style.borderRadius = '0'
        mobileHamburger.style.padding = '0'
        mobileHamburger.style.width = '30px'
        mobileHamburger.style.height = '30px'
        mobileHamburger.style.background = 'none'
        mobileHamburger.style.border = 'none'
        mobileHamburger.classList.toggle('menu-button-closed')
        if (listCountry.classList.contains('menu-list-country-opened')) {
          listCountry.classList.remove('menu-list-country-opened')
        }
      } else {
        mobileHamburger.style.left = mobileMenu.offsetWidth + 20 + 'px'
        mobileHamburger.style.borderRadius = '50%'
        mobileHamburger.style.padding = '10px'
        mobileHamburger.style.width = '50px'
        mobileHamburger.style.height = '50px'
        mobileHamburger.style.background = '#ffffff'
        mobileHamburger.style.border = '3px solid #FF7C1D'
        mobileHamburger.classList.toggle('menu-button-closed')
      }
    }

    mobileHamburger.addEventListener('click', function () {
      toggleMenu()
      toggleButton()
    })
    // Прижимаем нижнее меню если высота контенера обертки меню
    // выше чем сумма высот двух контейнеров внутри
    // var mobileMenuHeigth = mobileMenu.offsetHeight
    // var mobileMenuLogoHeight = mobileMenuLogo.offsetHeight
    // var mobileMenuContainerHeight = mobileMenuContainer.offsetHeight
    // var mobileMenuSecondContainerHeight = mobileMenuSecondContainer.offsetHeight

    // if ((mobileMenuContainerHeight + mobileMenuSecondContainerHeight + mobileMenuLogoHeight) < mobileMenuHeigth) {
    //  var margineSecondContainer = mobileMenuHeigth - (mobileMenuContainerHeight + mobileMenuSecondContainerHeight + mobileMenuLogoHeight)
    //  mobileMenuSecondContainer.style.top = margineSecondContainer + 'px'
    // }

    // Реализовываем выдвигающийся список стран в меню
    var listCountry = document.querySelector('.menu-list-country')
    var buttonListCountryOpen = document.querySelector('.menu-selected-country')
    var buttonListCountryClose = document.querySelector('.return-from-list-country')

    buttonListCountryOpen.addEventListener('click', function () {
      setTimeout(function () {
        listCountry.classList.toggle('menu-list-country-opened')
        mobileMenu.scrollTop = 0
        mobileMenu.style.overflowY = 'hidden'
      }, 300)
    })
    buttonListCountryClose.addEventListener('click', function () {
      listCountry.classList.toggle('menu-list-country-opened')
      mobileMenu.style.overflowY = 'scroll'
    })
  })()
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobileMenu.vue